// The Agent's request-only picker shares the same live/fallback source and
// physical-object filter as its route tool; nonphysical map annotations and
// temporary events are not offered as position or destination points.
import catalogue from '../../../graphs/peterhof_plan/data/navigation_objects.json';
export const PHYSICAL_TYPES = new Set(['f', 'm', 'w', 'c', 'e', 'p', 'v', 'u', 's']);
export type MuseumPoint = { id: string; label: string; lat: number; lon: number; iconType: string; ensemble: string | null };
export const MUSEUM_POINTS: MuseumPoint[] = catalogue.objects
  .filter((o) => PHYSICAL_TYPES.has(o.iconType) && typeof o.latitude === 'number' && typeof o.longitude === 'number' && Number.isFinite(o.latitude) && Number.isFinite(o.longitude))
  .map((o) => ({ id: String(o.id), label: o.title, lat: o.latitude!, lon: o.longitude!, iconType: o.iconType, ensemble: o.ensemble }))
  .sort((a, b) => a.label.localeCompare(b.label, 'ru'));
export const PARK_CENTER = MUSEUM_POINTS.find((p) => p.label === 'Большой каскад') ?? MUSEUM_POINTS[0]!;
export function validPosition(lat: number, lon: number): boolean {
  return Number.isFinite(lat) && Number.isFinite(lon) && Math.abs(lat) <= 90 && Math.abs(lon) <= 180;
}
